import CustomModal from "../custom-modal";
import { sanitize } from "dompurify";

const ConsentModal = ({ consentBody, onConsentAccepted, onConsentDeclined, ...otherProps }) => {
  const { text, acceptButton, declineButton } = consentBody || {};

  return (
    <CustomModal id="consent-modal" headerTitle="Importante" size="md" {...otherProps}>
      <div className="modal-body">
        {text ? (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitize(text ?? "", { ADD_ATTR: ["target"] }),
            }}
          ></div>
        ) : (
          <span></span>
        )}
        <div className="d-flex flex-column">
          <button onClick={onConsentAccepted} className="btn btn-custom btn-green mb-2">
            <i className="fas fa-check mr-2" />
            {acceptButton ?? "He leído el consentimiento y deseo comenzar con la encuesta"}
          </button>
          <button onClick={onConsentDeclined} className="btn btn-custom btn-red">
            <i className="fas fa-times mr-2" />
            {declineButton ?? "He leído el consentimiento, no deseo continuar con el proceso"}
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default ConsentModal;
